import getHouseRoute from '@plugin/searchRoute/modules/house'
import { createContext, useContext, useState } from 'react'
import { useBoolean } from 'react-use'

export const HouseSearchContext = createContext()
export default function useHouseSearchContext() {
  return useContext(HouseSearchContext)
}

export function useHouseSearchState(state) {
  const [filterData, setFilterData] = useState()
  const houseRoute = getHouseRoute()
  houseRoute.fromSlug(state.slug)
  // surrounding
  const [surrounding, toggleSurrounding] = useBoolean(houseRoute.surround)
  // keywords
  const [description, setDescription] = useState(houseRoute.description)

  // 是否有filter被打开
  const [filterOpen, toggleFilterOpen] = useBoolean(false)

  return {
    filterData,
    surrounding,
    description,
    filterOpen,
    toggleFilterOpen,
    toggleSurrounding,
    setDescription,
    setFilterData,
  }
}